import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Seo from "@/components/Seo";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import QuoteCalculator from "@/components/site/QuoteCalculator";
import AppointmentForm from "@/components/site/AppointmentForm";
import Footer from "@/components/site/Footer";
import AuthCallback from "@/components/site/AuthCallback";
import Dashboard from "@/components/site/Dashboard";
import { MobileCtaBar } from "@/components/site/MobileCtaBar";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import Expenses from "@/components/expenses/Expenses";
import ResetPassword from "@/components/site/ResetPassword";
import { LanguageProvider } from "@/lib/i18n";

const Landing = () => {
  const lenisRef = useRef(null);
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: id === "top" ? -120 : -72 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleBook = (quote) => {
    setPrefill(quote);
    scrollTo("book");
  };

  const handleQuoteService = () => {
    scrollTo("quote");
  };

  return (
    <div className="bg-[#FAF8F5]">
      <Seo
        title="PERETE Flooring & Carpet Installation — Centralia · Chehalis · Olympia WA"
        siteName="PERETE Flooring and Carpet Installation"
        description="Carpet, laminate and luxury vinyl plank installation in Centralia, Chehalis and Olympia WA. Get an instant square-yard quote online and book a free in-home measurement visit. Call 360-861-7655."
        image="/logo.png"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "PERETE Flooring and Carpet Installation Inc.",
          telephone: "+1-360-861-7655",
          description:
            "Carpet, laminate, LBP/LVP, glue down carpet installation, flooring repair and carpet restretching.",
          areaServed: ["Centralia, WA", "Chehalis, WA", "Olympia, WA"],
        }}
      />
      <Navbar onNavigate={scrollTo} />
      <Hero onNavigate={scrollTo} />
      <Marquee />
      <Services onQuoteService={handleQuoteService} />
      <Gallery />
      <Reviews />
      <QuoteCalculator onBook={handleBook} />
      <AppointmentForm prefill={prefill} />
      <Footer onNavigate={scrollTo} />
      <MobileCtaBar onNavigate={scrollTo} />
      <WhatsAppButton />
    </div>
  );
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/gastos" element={<Expenses />} />
      <Route path="/expenses" element={<Expenses />} />
      <Route path="/restablecer" element={<ResetPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
